<template>
  <div>
    <div class="titleAfter">生理诊断</div>
    <div class="health">
      <div class="health-title">健康值</div>
      <div class="health-list">
        <div class="list-left">
          <div class="left-item">身体基本节奏值</div>
          <div class="left-item">左右脑平衡状态</div>
        </div>
        <div class="list-center">
          <div class="center-item">30.85</div>
          <div class="center-item">2.99</div>
        </div>
        <div class="list-right">极好</div>
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.titleAfter {
  position: relative;
  font-weight: bold;
  color: #4aefff;
  margin-bottom: 20px;
}
.titleAfter::after {
  content: "";
  position: absolute;
  left: -8px;
  top: 2px;
  width: 3px;
  height: 14px;
  background: #4aefff;
  border-radius: 38px 38px 38px 38px;
}
.health-title {
  position: relative;
  color: #6cc6f3;
  padding-left: 10px;
  margin-bottom: 20px;
}
.health-title::after {
  content: "";
  position: absolute;
  left: -4px;
  top: 4px;
  width: 10px;
  height: 10px;
  background: #6cc6f3;
  border-radius: 50%;
}
.health-list{
    display: flex;
    align-items: center;
    text-align: center;
    margin-bottom: 20px;
    .list-left{
        width:360px;
        margin-right: 2px;
        .left-item{
            line-height: 50px;
            height: 50px;
            background: #124E91;
            color: #6cc6f3;
            margin-bottom: 2px;
        }
    }
    .list-center{
        width:180px;
        margin-right: 2px;
        .center-item{
            line-height: 50px;
            height: 50px;
            background: #124E91;
            color: #6cc6f3;
            margin-bottom: 2px;
        }
    }
    .list-right{
        width:180px;
        line-height: 102px;
        height: 102px;
        background: #124E91;
        color: #6cc6f3;
    }
}
</style>
